import { AxiosReports, AxiosGlobalFilters, AxiosReportLas } from '../config';
import qs from 'qs';
import { applyArrayFilter } from 'utils/applyArrayFilter';

const FiltersService = {
  getActivityResponsibles: ({ companyId, unitId }) => {
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/responsaveistecnicos`,
        params: {
          unidadeId: unitId,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getResponsibleARTCertificateDocuments: ({ companyId, unitId }) => {
    let ART_TYPE = 34;
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/documentos`,
        params: {
          unidadeId: unitId,
          tipoDocumentoId: ART_TYPE,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getResponsibleTRTCertificateDocuments: ({ companyId, unitId }) => {
    let TRT_TYPE = 35;
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/documentos`,
        params: {
          unidadeId: unitId,
          tipoDocumentoId: TRT_TYPE,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getDocuments: ({ companyId, unitId }) => {
    if (companyId && unitId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/documentos`,
        params: {
          unidadeId: unitId,
        },
        headers: {
          EmpresaId: companyId,
          UnidadeId: unitId,
        },
      });
    }
  },
  getSystems: ({ companyId, unitIds, unitGroupIds, unitSubgroupIds }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/V1/sistemas`,
        params: {
          unidadeId: unitIds,
          GrupoUnidadeId: unitGroupIds,
          SubGrupoUnidadeId: unitSubgroupIds,
        },
        headers: {
          empresaId: companyId,
        },
      });
    }
  },
  getPMOCActivitiesPlans: ({ companyId, unitId, systemIds }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/planosatividades/ativos`,
      params: {
        empresaId: companyId,
        sistemasIds: systemIds,
        unidadeId: unitId,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  getPMOCActivitiesPlansCount: ({ companyId, unitId = undefined }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/planosatividades/ativos`,
      params: {
        empresaId: companyId,
        unidadeId: unitId,
      },
    });
  },

  getEstadosAtivos: ({ EmpresaId, GrupoUnidadeId, SubGrupoUnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: 'v1/estados/ativos',
      params: {
        GrupoUnidadeId,
        SubGrupoUnidadeId,
      },
      headers: {
        EmpresaId,
      },
    });
  },

  getUnitGroups: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: '/v1/gruposUnidades/ativas',
        headers: {
          empresaId: companyId,
        },
      });
    }
  },
  getUnitSubgroups: ({ companyId, unitGroupIds }) => {
    let grupoUnidade;
    let GrupoUnidadeIds;
    if (typeof unitGroupIds === 'number') {
      grupoUnidade = unitGroupIds;
    } else if (Array.isArray(unitGroupIds)) {
      GrupoUnidadeIds = unitGroupIds;
    } else if (typeof unitGroupIds === 'string' && unitGroupIds.length > 0) {
      grupoUnidade = Number(unitGroupIds);
    }
    const params = {
      GrupoUnidadeId: grupoUnidade,
      GrupoUnidadeIds,
      EmpresaId: companyId,
    };
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: '/v1/subgruposunidades/ativas',
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getUnits: ({ companyId, unitSubgroupIds, stateIds, unitGroupIds, citieId }) => {
    let subGrupo = null;
    let grupoUnidade = null;
    let GrupoUnidadeIds = null;
    let SubGrupoUnidadeIds = null;
    if (typeof unitGroupIds === 'number') {
      grupoUnidade = unitGroupIds;
    } else if (Array.isArray(unitGroupIds)) {
      GrupoUnidadeIds = unitGroupIds;
    }
    if (typeof unitSubgroupIds === 'number') {
      subGrupo = unitSubgroupIds;
    } else if (Array.isArray(unitSubgroupIds)) {
      SubGrupoUnidadeIds = unitSubgroupIds;
    } else {
      subGrupo = null;
      SubGrupoUnidadeIds = null;
    }
    const params = {
      grupoUnidadeId: grupoUnidade,
      GrupoUnidadeIds,
      SubGrupoUnidadeIds,
      empresaId: companyId,
      subGrupoUnidadeId: subGrupo,
      EstadoId: stateIds,
      CidadeId: citieId,
    };

    // Remove chaves com valor null ou undefined
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: '/v1/unidades/ativas',
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },

  getAreasLh: ({ empresa, siteId, grupoAreaId, subGrupoAreaId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: 'v1/areas/ativas',
      params: {
        siteId,
        grupoAreaId,
        subGrupoAreaId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },

  getEquipmentTypesAvailibility: ({ EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/tiposequipamentos`,
      headers: {
        EmpresaId,
        UnidadeId,
      },
    });
  },
  getEquipmentGroup: ({ empresaId, unidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/gruposEquipamentos/ativos?empresaId=${empresaId}&unidadeId=${unidadeId}`,
    });
  },
  getEquipmentsLh: ({ empresa, SiteId, AreaId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: 'v1/equipamentos/ativos',
      params: {
        SiteId,
        AreaId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  getEquipamentosAtivos: ({
    pageSize = 20,
    pageIndex = 1,
    empresaId,
    siteId,
    fornecedoresIds,
    sistemaId,
    tipoEquipamentoId,
    grupoAreaId,
    subGrupoAreaIds,
    areaId,
    grupoEquipamentoId,
    planoAtividadeId,
    fornecedorId,
  }) => {
    const params = {
      PageSize: pageSize,
      PageIndex: pageIndex,
    };
    const headers = {
      EmpresaId: empresaId,
    };

    applyArrayFilter(params, siteId, 'SiteId');
    applyArrayFilter(params, fornecedoresIds, 'FornecedoresIds');
    if (sistemaId) params.SistemaId = sistemaId;
    if (tipoEquipamentoId) params.TipoEquipamentoId = tipoEquipamentoId;
    applyArrayFilter(params, grupoAreaId, 'GrupoAreaId');
    applyArrayFilter(params, subGrupoAreaIds, 'SubGrupoAreaId');
    applyArrayFilter(params, areaId, 'AreaId');
    applyArrayFilter(params, grupoEquipamentoId, 'GrupoEquipamentoId');
    applyArrayFilter(params, planoAtividadeId, 'PlanoAtividadeId');
    if (fornecedorId) params.FornecedorId = fornecedorId;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/equipamentos/ativos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getGruposEquipamentos: ({ empresaId, siteId, search, pageIndex = 1, pageSize = 1000 }) => {
    const params = {
      empresaId: empresaId,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    applyArrayFilter(params, siteId, 'SiteId');
    if (search) params.Search = search;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/gruposEquipamentos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },

  getTiposEquipamentos: ({ empresaId, unidadeId }) => {
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/tiposequipamentos',
      headers,
    });
  },

  getGruposAreasAtivos: ({ empresaId, unidadeId, fornecedoresIds }) => {
    const params = {
      empresaId: empresaId,
      unidadeId: unidadeId,
    };
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };
    applyArrayFilter(params, fornecedoresIds, 'fornecedoresIds');

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/gruposareas/ativos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getSubGruposAreasAtivos: ({ empresaId, unidadeId, grupoAreaId, fornecedoresIds }) => {
    const params = {
      empresaId: empresaId,
      unidadeId: unidadeId,
    };
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };
    if (grupoAreaId) params.grupoAreaId = grupoAreaId;
    applyArrayFilter(params, fornecedoresIds, 'fornecedoresIds');

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/subgruposareas/ativos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getAreasAtivos: ({
    empresaId,
    siteId,
    fornecedoresIds,
    grupoAreaId,
    subGrupoAreaId,
    search,
    pageIndex = 1,
    pageSize = 1000,
    usuarioId,
    areaId,
    planoAtividadeId,
  }) => {
    const params = {
      pageSize: pageSize,
      pageIndex: pageIndex,
    };
    const headers = {
      EmpresaId: empresaId,
    };
    applyArrayFilter(params, siteId, 'SiteId');
    applyArrayFilter(params, fornecedoresIds, 'FornecedoresIds');

    applyArrayFilter(params, grupoAreaId, 'GrupoAreaId');
    applyArrayFilter(params, subGrupoAreaId, 'SubGrupoAreaId');

    if (search) params.Search = search;
    if (usuarioId) params.UsuarioId = usuarioId;
    applyArrayFilter(params, areaId, 'AreaId');
    applyArrayFilter(params, planoAtividadeId, 'PlanoAtividadesId');
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/areas/ativas',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getSlas: ({ companyId, unitIds }) => {
    if (companyId) {
      return AxiosReports({
        method: 'post',
        url: `/filters/${companyId}/slas`,
        data: {
          unitIds,
        },
      });
    }
  },
  getCompanyDepartments: ({ companyId, UnidadeId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/setores`,
        params: {
          EmpresaId: companyId,
          UnidadeId,
        },
        headers: {
          EmpresaId: companyId,
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      });
    }
  },
  getMaterials: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/materiais`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getCategories: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/categorias`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getMeasurementUnits: ({ companyId }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/UnidadesMedicoes`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  getMeasurementUnit: ({ companyId, id }) => {
    if (companyId) {
      return AxiosGlobalFilters({
        method: 'get',
        url: `/v1/UnidadesMedicoes?UnidadeMedicao=${id}`,
        headers: {
          EmpresaId: companyId,
        },
      });
    }
  },
  docTypes: () => {
    return AxiosReportLas({
      method: 'get',
      url: '/v1/Documento/tipos',
      headers: {
        'content-type': 'application/json',
      },
    });
  },
  getUserLh: ({ empresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/usuarios',
      params: {
        UnidadeId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresaId,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  getFornecedores: ({ empresaId, unidade }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/empresas/fornecedor',
      params: {
        unidade,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresaId,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  getPrioridadesOcorrencias: ({ EmpresaId, UnidadeId }) => {
    const headers = {
      'content-type': 'application/json',
      EmpresaId,
    };
    if (UnidadeId) {
      headers.UnidadeId = UnidadeId;
    }
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v2/prioridadesocorrencias',
      headers,
    });
  },
  getTiposCorrecoes: ({ EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: '/v3/correcoes/tipos',
      headers: {
        'contetn-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  getCidades: ({ EmpresaId, UnidadeId, SubGrupoUnidadeId, GrupoUnidadeId, EstadoId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/cidades/ativas',
      params: {
        EstadoId,
        SubGrupoUnidadeId,
        GrupoUnidadeId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
};

export { FiltersService };
/*
Segue os endpoints para serem alterados
/filters/${companyId}/slas
//ja existe, mas não em HOM, eu fiz pro projeto de SLA mas ainda não subi, quando subir te mando aqui para voce alterar

/filters/${companyId}/priorities
{{lighthouseurl}}/v2/prioridadesocorrencias

/filters/${companyId}/departments
{{lighthouseurl}}/v1/setores

/filters/${companyId}/occurrence-status
1	Analisada
2	Solucionada
3	Não Analisada
4	Inativo
5	Expirado

/filters/${companyId}/correction-status
{{lighthouseurl}}/v3/correcoes/tipos
*/
